import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Button from "../button";
import Col from "../col";
import FormControl from "../form/formControl";
import { useFilterForm } from "./hooks";
import {
  FilterFormProps,
  FilterFormValues,
  FilterInputGroupProps,
} from "./types";
import { getMaxIndex } from "./utils";

const FilterInputGroups = ({
  id,
  variant: { maxFilterNum, ...variant },
}: FilterInputGroupProps) => {
  const fields = useWatch<FilterFormValues>({ name: "values" }) as any[];
  const filterType = useWatch<FilterFormValues>({ name: "operation" });
  const maxIndex = getMaxIndex(fields, filterType, maxFilterNum);

  const controlProps = {
    ...variant,
    ...(variant.type === "number" ? { thousandSeparator: false } : {}),
    size: "sm",
  };

  return fields
    .filter((_, index) => index <= maxIndex)
    .map((_, index) => (
      <Col key={`${id ?? "filter"}_${index}`} gap="sm">
        <FormControl {...controlProps} size="sm" name={`values.${index}.0`} />
        {filterType === "between" && (
          <FormControl {...controlProps} size="sm" name={`values.${index}.1`} />
        )}
        {index !== maxIndex && <span className="text-center">OR</span>}
      </Col>
    ));
};

const FilterForm = (props: Readonly<FilterFormProps>) => {
  const { t } = useTranslation();
  const { id, variant, close } = props;
  const { filterOptions, onClear, onSubmit } = useFilterForm(props);

  return (
    <form onSubmit={onSubmit}>
      <Col gap="md">
        <Col gap="sm">
          <FormControl
            type="select"
            size="sm"
            name="operation"
            options={filterOptions}
          />
          <FilterInputGroups id={id} variant={variant} />
        </Col>
        <Col gap="sm">
          <Button
            size="sm"
            className="w-full "
            variant="secondary"
            type="submit"
            onClick={close}
          >
            {t("common.label.apply", "Apply")}
          </Button>
          <Button
            size="sm"
            className="w-full "
            variant="light"
            type="submit"
            onClick={onClear}
          >
            {t("common.label.clear", "Clear")}
          </Button>
        </Col>
      </Col>
    </form>
  );
};

export default FilterForm;
